export const mockAppointmentDataInput = {
  currentUser: {
    progress: {
      stats: [
        {
          count: 27,
          kind: 'live_lesson_total_lessons',
        },
        {
          count: 73,
          kind: 'live_lesson_total_exercises',
        },
        {
          count: 70,
          kind: 'live_lesson_exercises_feeling_good',
        },
        {
          count: 21,
          kind: 'live_lesson_total_hours',
        },
      ],
    },
    appointment: {
      updatedAt: '2020-07-21T20:46:00Z',
      chatSessionId: '6NdwUYJKigTQrYyDuzWKGbpm',
      averageStudentRating: 0,
      tutor: {
        login: 'wilmer_arias',
        avatarUrl:
          'https://secure.gravatar.com/avatar/dbbc5c77aed5b35d9d65c1d9f16fca89?default=retro&secure=true&size=256',
      },
      exercises: {
        nodes: [
          {
            imageUrl:
              'https://chatterdev.s3.amazonaws.com/exercises/images/000/002/245/display/vbirreg_reflexivos.jpg?1513166905',
          },
        ],
      },
      unit: {
        cefrLevel: 'A1',
        name: 'Actividades diarias',
      },
      lastSeenTimeAgo: '3 months ago',
      chatSessionArchiveUrl: 'testurl',
    },
  },
}

export const expectedAppointmentDataOutput = {
  showPlaceholder: false,
  activityInfo: {
    lessonThumbnail:
      'https://chatterdev.s3.amazonaws.com/exercises/images/000/002/245/display/vbirreg_reflexivos.jpg?1513166905',
    date: '3 months ago',
    subTitle: 'Actividades diarias',
    cefrLevel: 'A1',
  },
  liveLessonInfo: {
    tutorAvatarUrl:
      'https://secure.gravatar.com/avatar/dbbc5c77aed5b35d9d65c1d9f16fca89?default=retro&secure=true&size=256',
    tutorLogin: 'wilmer_arias',
    liveLessonReplayUrl: 'testurl',
    averageStudentRating: 0,
  },
  footerStats: [
    {
      count: 27,
      kind: 'live_lesson_total_lessons',
      label: 'total lessons',
      number: 27,
    },
    {
      count: 73,
      kind: 'live_lesson_total_exercises',
      label: 'total exercises',
      number: 73,
    },
    {
      count: 70,
      kind: 'live_lesson_exercises_feeling_good',
      label: 'feeling good',
      number: 70,
    },
    {
      count: 21,
      kind: 'live_lesson_total_hours',
      label: 'total hours',
      number: 21,
    },
  ],
  widgetType: 'liveLesson',
  linkHash: '6NdwUYJKigTQrYyDuzWKGbpm',
}

export const mockProgressDataInput = {
  currentUser: {
    progress: {
      stats: [
        {
          count: 27,
          kind: 'live_lesson_total_lessons',
        },
        {
          count: 73,
          kind: 'live_lesson_total_exercises',
        },
        {
          count: 70,
          kind: 'live_lesson_exercises_feeling_good',
        },
        {
          count: 21,
          kind: 'live_lesson_total_hours',
        },
        {
          count: 1,
          kind: 'media_mastered',
        },
        {
          count: 6,
          kind: 'media_completed',
        },
        {
          count: 3,
          kind: 'writing_completed',
        },
        {
          count: 0,
          kind: 'writing_tutor_correction',
        },
        {
          count: 20,
          kind: 'concepts_completed',
        },
        {
          count: 1689,
          kind: 'minutes',
        },
      ],
    },
  },
}
